function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _object_destructuring_empty(o) {
    if (o === null || o === void 0) throw new TypeError("Cannot destructure " + o);
    return o;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { createRecordType, defineMigrations } from "@supersig/store";
import { T } from "@supersig/validate";
import { nanoid } from "nanoid";
import { getIndexAbove } from "../../utils/reordering/reordering";
import { idValidator } from "../misc/id-validator";
export const PaywallProductValidator = T.model("paywall_product", T.object({
    id: idValidator("paywall_product"),
    typeName: T.literal("paywall_product"),
    identifier: T.string,
    index: T.string
}));
export const Versions = {
    AddIndex: 1
};
const primaryIndex = "a0";
const secondaryIndex = getIndexAbove(primaryIndex);
const tertiaryIndex = getIndexAbove(secondaryIndex);
const idToIndex = {
    [createPaywallProductId("primary")]: primaryIndex,
    [createPaywallProductId("secondary")]: secondaryIndex,
    [createPaywallProductId("tertiary")]: tertiaryIndex
};
export const SWPaywallProductRecordType = createRecordType("paywall_product", {
    migrations: defineMigrations({
        currentVersion: Versions.AddIndex,
        migrators: {
            [Versions.AddIndex]: {
                up: (_param)=>{
                    var rest = _extends({}, _object_destructuring_empty(_param));
                    const index = idToIndex[rest.id];
                    console.log(`[!] index`, index, rest.id, rest);
                    return _object_spread_props(_object_spread({}, rest), {
                        index: idToIndex[rest.id]
                    });
                },
                down: (_param)=>{
                    var { index } = _param, rest = _object_without_properties(_param, [
                        "index"
                    ]);
                    return _object_spread({}, rest);
                }
            }
        }
    }),
    validator: PaywallProductValidator,
    scope: "document"
}).withDefaultProperties(()=>({}));
export function isPaywallProduct(record) {
    if (!record) return false;
    return record.typeName === "paywall_product";
}
export function isPaywallProductId(id) {
    if (!id) return false;
    return id.startsWith("paywall_product:");
}
/** @public */ export function createPaywallProductId(id) {
    return `paywall_product:${id !== null && id !== void 0 ? id : nanoid()}`;
}
export function getProductPrefixFromId(id) {
    if (!id) return "";
    return id.split(":")[1];
}
export const castPaywallProductId = (id)=>{
    return {
        toReferenceName () {
            return id.replace(/^paywall_product:/, "");
        }
    };
};
